;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { PrismicNextImage } from '@prismicio/next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Link from '@/components/atoms/Link';
import Tag from '@/components/atoms/Tag';
import { ArrowRightIcon } from '@/public/assets/svg';
import { ROUTES } from '@/routes';
import { BlogListItemProps, Category } from './types';
const BlogListItem = ({
  item
}: BlogListItemProps) => {
  const data = item?.data?.tags[0] as Category;
  const {
    t
  } = useTranslation();
  return <Link href={ROUTES.blogPost(item.uid)} className="shadow-elevation-4 hover:border-primary-500 flex w-full max-w-full flex-col overflow-hidden rounded-[0.625rem] border border-gray-200 sm:max-w-[500px] lg:max-w-[363px]" data-sentry-element="Link" data-sentry-component="BlogListItem" data-sentry-source-file="index.tsx">
      <PrismicNextImage fallbackAlt="" fallback={<div className="h-full w-full bg-gray-200" />} className="aspect-40/21 h-full w-full object-cover" field={item.data.image} data-sentry-element="PrismicNextImage" data-sentry-source-file="index.tsx" />
      <div className="flex h-full flex-col justify-between bg-white px-5 py-6 lg:px-6">
        <div className="mb-4 flex items-center gap-2 text-gray-500">
          {!!data?.category.data?.title && <Tag className="w-min" variant={data?.variant || 'orange'}>
              {data.category.data.title}
            </Tag>}
          {item.data.read_time && <>
              •{' '}
              <p className="text-h9">
                {t('common.readTimeLabel', {
              readTime: item.data.read_time
            })}
              </p>
            </>}
        </div>
        <h3 className="text-body-5 child:inline mb-3 line-clamp-2 font-bold text-gray-600 lg:min-h-12">
          {item.data.title}
        </h3>
        <div className="mb-5 lg:min-h-16">
          <p className="text-body-7 child:inline line-clamp-3 text-gray-500">
            {item.data.description}
          </p>
        </div>
        <div className="flex items-center text-gray-600 hover:opacity-50">
          {t('common.readMoreLabel')} <ArrowRightIcon className="h-6 w-6" data-sentry-element="ArrowRightIcon" data-sentry-source-file="index.tsx" />
        </div>
      </div>
    </Link>;
};
export default BlogListItem;